import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { format } from "date-fns";
import { CircularProgress, MenuItem } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import ic_filter from "../utils/ic_filter.png"
import TextField from "@mui/material/TextField";

const QuotationsListViewFull = (props) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"


  const todayDate = format(new Date(), "yyyy-MM-dd");

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

  const userAccessGroup = currentUserObject[0].accessgrp;

  let defaultStage = "-"

  if (userAccessGroup?.trim().toUpperCase() == "ADMIN") {
    // defaultStage = "For Approval" earlier 
    defaultStage = "-"
  }

  const [currentSelectedStage, setCurrentSelectedStage] = useState(defaultStage)

  const [initialFilterObject, setInitialFilterObject] = useState({
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_creator_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
        userAccessGroup?.trim().toUpperCase() != "ADMIN" &&
        userAccessGroup?.trim().toUpperCase() != "CADMIN" &&
        userAccessGroup?.trim().toUpperCase() != "CACCOUNTS" &&
        userAccessGroup?.trim().toUpperCase() != "C STORES" && 
        userAccessGroup?.trim().toUpperCase() != "C ACC JUNIOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    task_owner_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
        userAccessGroup?.trim().toUpperCase() != "ADMIN" &&
        userAccessGroup?.trim().toUpperCase() != "CADMIN" &&
        userAccessGroup?.trim().toUpperCase() != "CACCOUNTS" &&
        userAccessGroup?.trim().toUpperCase() != "C STORES" && 
        userAccessGroup?.trim().toUpperCase() != "C ACC JUNIOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    free_text: "-",
  });

  const [showLeadFilter, setShowLeadFilter] = useState(false);
  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [quotationList, setQuotationList] = useState(null);
  const [quotationDetailsData, setQuotationDetailsData] = useState(null);
  const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const callApi = () => {
    console.log("currentPageNumber ", currentPageNumber);

    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    if (!currentUserObject) {
      console.error("No user data found in localStorage");
      return;
    }

    const userAccessGroup = currentUserObject[0].accessgrp;

    console.log("currentUserDepartment:", currentUserDepartment);
    console.log("userAccessGroup:", userAccessGroup);

    fetchQuotationList(
      userAccessGroup,
      currentUserDepartment,
      initialFilterObject
    );
  }

  useEffect(() => {
    if (currentPageNumber) {
      callApi()
    }
  }, [currentPageNumber]);

  useEffect(() => {

    if (initialFilterObject) {
      console.log("freetext changed calling api")
      callApi()
    }

  }, [initialFilterObject])

  const fetchQuotationList = (
    userAccessGroup,
    currentUserDepartment,
    filterObjectFromModal
  ) => {

    console.log("filterObjectFrom Modal and userAccessGroup>>", filterObjectFromModal, userAccessGroup)

    setLoading(true);

    try {
      let url = "";

      if (userAccessGroup?.trim().toUpperCase() === "COORDINATOR" || userAccessGroup?.trim().toUpperCase() === "ADMIN" || userAccessGroup?.trim().toUpperCase() === "CADMIN" || userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" || userAccessGroup?.trim().toUpperCase() == "C STORES" || userAccessGroup?.trim().toUpperCase() == "C ACC JUNIOR"  ) {
        url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskMainListFilter/${company_code_from_local_storage}/ProposalFilter/${filterObjectFromModal.task_owner_id}/${filterObjectFromModal.task_creator_id}/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${currentSelectedStage}`;
      } else {
        url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMTaskMainListFilter/${company_code_from_local_storage}/ProposalFilter/${filterObjectFromModal.task_owner_id}/-/-/-/${currentUserDepartment}/${filterObjectFromModal.fromDate}/${filterObjectFromModal.toDate}/${filterObjectFromModal.free_text}/${currentPageNumber}/${currentSelectedStage}`;
      }

      axios.get(url).then((res) => {
        console.log("Quotation List:", res.data);
        setQuotationList(res.data);
      });
    } catch (error) {
      console.error("Error fetching quotations:", error);
    } finally {
      setLoading(false);
    }
  };



  const giveBackStageStyle = (stage) => {
    switch (stage) {
      case "Approved":
        return "inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset";

      case "For Approval":
        return "inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset";

      case "Draft":
        return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";

      default:
        return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";
    }
  };


  const applyFilters = () => { };

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  const goToAdminQuotationPage = (clickedListItem) => {


    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_account: clickedListItem.Account,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_coordinator: clickedListItem.Coordinator,
      deptno: clickedListItem.Dept
    }
    console.log("selectedLead>>> Admin List", selectedLead)

    navigate(`/quoteLeadAdmin`, { state: { selectedLead } })
  }


  const goToUserQuotationPage = (clickedListItem) => {

    console.log("clickedListItem ", clickedListItem)


    let selectedLead = {
      ...clickedListItem,
      lead_id: clickedListItem.Lead_ID,
      lead_organization: clickedListItem.Customer,
      lead_coordinator: clickedListItem.Coordinator,
      lead_salesperson: clickedListItem.Sales_Person,
      lead_account: clickedListItem.Account,
      deptno: clickedListItem.Dept,
      lead_email: clickedListItem.lead_email
    }
    console.log("selectedLead>>>", selectedLead)

    let previous_page_url_last_part = {name:"quotationsListViewFull"}

    navigate('/quoteLead', { state: { selectedLead , previous_page_url_last_part } })
  }


  const handleInput = (e) => {

    if (e.target.value == "") {
      setInitialFilterObject((prev) => ({ ...prev, free_text: "-" }))
    } else {
      setInitialFilterObject((prev) => ({ ...prev, free_text: [e.target.value] }))
    }



  }

  const handleChange = (e) => {
    setCurrentSelectedStage(e.target.value)
  }

  useEffect(() => {

    if (currentSelectedStage) {
      callApi()
    }

  }, [currentSelectedStage])

  const checkIfPreCodeItemPresent = (list) => {

    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/PROPOSAL_PRE-ORDER-ITEM/${list.Prop_No}/${currentUserDepartment}`
    axios.get(apiUrl).then((res) => {

      console.log("res.data[0].Column1 ", res.data[0].Column1)

      if (res.data[0].Column1 > 0) {
        alert("Customer account creation approval pending - (Finance Department)")
      } else {
        navigate('/convert_to_sales_order', { state: { list } })
      }

    }).catch((err) => {

    })

  }

  return (
    <div className="min-h-screen px-6">
      <div className="flex justify-between items-center mb-4 ">
        {quotationDetailsPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg p-6 max-w-[30%] w-full shadow-lg relative">
              <h2 className="text-lg font-semibold mb-4">Quotation Details</h2>

              {quotationDetailsData?.map((detail, index) =>
                console.log("detail::", detail)
              )}
              {/* {quotationDetailsData?.map((detail,index)=> */}
              {
                quotationDetailsData.length > 0 && (
                  <div className="space-y-3  max-h-[400px] max-w-[500px]   overflow-y-auto scrollbar-hide">
                    <div className="p-4">
                      <p>
                        <strong>Quotation Number:</strong>{" "}
                        {quotationDetailsData[0].so_no}
                      </p>
                      <p>
                        <strong>Date:</strong> {quotationDetailsData[0].so_date}
                      </p>
                      <p>
                        <strong>Revision Number:</strong>{" "}
                        {quotationDetailsData[0].jv_num}
                      </p>
                      <p>
                        <strong>Customer Name:</strong>{" "}
                        {quotationDetailsData[0].accdesc}
                      </p>
                      <p>
                        <strong>Customer Account:</strong>{" "}
                        {quotationDetailsData[0].cust_acc}
                      </p>
                      <p>
                        <strong>Amount:</strong>{" "}
                        {quotationDetailsData[0].so_amount}
                      </p>
                      <p>
                        <strong>Salesperson:</strong>{" "}
                        {quotationDetailsData[0].sale_man}
                      </p>
                      <p>
                        <strong>Department No:</strong>{" "}
                        {quotationDetailsData[0].deptno}
                      </p>
                      <p>
                        <strong>Status:</strong>{" "}
                        {quotationDetailsData[0].so_status}
                      </p>
                    </div>

                    {quotationDetailsData?.map((detail, index) => (
                      <div className="border rounded-md p-4">
                        <p>items{detail.length}</p>
                        <p>
                          <strong>Item Code:</strong> {detail?.so_icode}
                        </p>
                        <p>
                          <strong>Item Description:</strong> {detail?.idesc}
                        </p>
                      </div>
                    ))}


                  </div>
                )
                // ) : (
                //   <p className="text-gray-500">No data available</p>
                // )
              }

              {/* Close Button */}
              <button
                onClick={() => setQuotationDetailsPopup(false)}
                className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              >
                Close
              </button>
            </div>
          </div>
        )}

        <h3 className="text-xl font-normal text-gray-800 ">Quotations List</h3>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>

        <div className="me-4">
          <TextField
            select
            label={"Stage"} // Dynamically updated label
            name="territory"
            value={currentSelectedStage}
            onChange={handleChange}
            fullWidth
            variant="standard"
            id="territory"
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Figtree, sans-serif",
              },
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important", // Removes any shadow applied
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Stage
            </MenuItem>
            <MenuItem value="-">All</MenuItem>
            <MenuItem value="Draft">Draft</MenuItem>
            <MenuItem value="For Approval">For Approval</MenuItem>
            <MenuItem value="Approved">Approved</MenuItem>
            <MenuItem value="Customer Submission & Awaiting Approval">Customer Submission & Awaiting Approval</MenuItem>
            <MenuItem value="Customer Approval">Customer Approval</MenuItem>
            <MenuItem value="Customer Rejection-Negotiation">Customer Rejection-Negotiation</MenuItem>

          </TextField>
        </div>

        <input className="rounded me-2" placeholder="Search in Quotation" onChange={(e) => handleInput(e)} />

        <button style={{ display: "flex", alignItems: "center" }} onClick={() => setShowLeadFilter((prev) => !prev)}>
          <img style={{ width: "15px", height: "15px" }} src={ic_filter} />
          Filter
        </button>{" "}
        {currentPageNumber != 1 && (
          <button
            className="bg-transparent hover:bg-blue-500 text-xs text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
            onClick={() =>
              setCurrentPageNumber((prev) => (prev - 1 >= 1 ? prev - 1 : 1))
            }
          >
            Previous
          </button>
        )}
        <button
          onClick={() => setCurrentPageNumber((prev) => prev + 1)}
          className="bg-transparent hover:bg-blue-500 text-xs text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
          style={{ marginLeft: "10px" }}
        >
          Next
        </button>{" "}
      </div>

      <div className="bg-white rounded-lg shadow-sm mt-2">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-200 text-gray-600 text-sm">
              <th className="p-1">Quotation Number</th>
              <th className="p-1">Lead Id</th>
              <th className="p-1">Date</th>
              <th className="p-1">Rev No</th>
              <th className="p-1">Customer Name</th>
              <th className="p-1">Customer Account</th>
              <th className="p-1">Amount</th>
              <th className="p-1">Salesperson</th>
              <th className="p-1">Project name</th>

              <th className="p-1">Dept No</th>
              <th className="p-1">Status</th>
              <th className="p-1 text-center w-[240px]">Action</th>
            </tr>
          </thead>
          <tbody>
            {quotationList?.map((list, index) => (
              <tr key={index} className="border-b text-sm hover:bg-gray-50">
                <td className="p-1">{list.Prop_No}</td>
                <td className="p-1">{list.Lead_ID}</td>

                {/* <td className="p-1 ">{list.so_date}</td> */}
                <td className="p-1">
                  {dayjs(list.Date).format("DD/MM/YYYY")}
                </td>
                <td className="p-1">{list.jv_num}</td>
                <td className="p-1">{list.Customer}</td>
                <td className="p-1">{list.Account}</td>
                <td className="p-1">{list.Amount}</td>
                <td className="p-1">
                  <div>
                    <p>
                      {list.Sales_Person}
                    </p>
                    <p>
                      {list.Sales_person_Name}
                    </p>
                  </div>
                </td>
                <td className="p-1">{list.Project}</td>
                <td className="p-1">{list.Dept}</td>
                <td className="p-1">
                  <span className={giveBackStageStyle(list.Stage)}>
                    {list.Stage}
                  </span>
                </td>
                <td className="p-1 ">
                  <div className="flex justify-between items-center gap-1">

                    {currentUserAccessGroup?.trim().toUpperCase() == "ADMIN" || currentUserAccessGroup?.trim().toUpperCase() == "CADMIN" ?

                      <button
                        className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                        // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                        onClick={() => goToAdminQuotationPage(list)}
                      >
                        Quotation Details
                      </button>
                      :

                      <button
                        className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs"
                        // onClick={ () => quotationDetails(list.Prop_No, list.Dept) }

                        onClick={() => goToUserQuotationPage(list)}
                      >
                        Quotation Details
                      </button>
                    }

                    {list.Stage == "Won -Sales Order" &&
                      <button onClick={() => {
                        checkIfPreCodeItemPresent(list)
                      }} className="bg-gray-500 text-white">Convert to Sales Order</button>
                    }




                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {loading ? (
        <p className="inset-0 fixed flex justify-center items-center">
          Loading quotations... <CircularProgress size={24} />
        </p> // Show loader while fetching
      ) : (
        <ul>
          {/* {quotationList?.map((quote, index) => (
            <li key={index}>{quote.name}</li>
          ))} */}
        </ul>
      )}

      {showLeadFilter && (
        <QuotationListFilterModal
          applyFilters={applyFilters}
          closeFilter={() => setShowLeadFilter(false)}
          fetchQuotationList={fetchQuotationList}
        />
      )}
    </div>
  );
};

export default QuotationsListViewFull;
